import Admin from "../Admin";
import Dashboard from "../Dashboard";
import InformationCenter from "../InformationCenter";
import LaptopRental from "../Laptop";
import Setting from "../Setting";
import Staff from "../Staff";
import Student from "../Student";

function ContainerTab({ currentTab }: { currentTab: number }) {
    return <div className="w-full h-full">
        {currentTab === 1 && <Dashboard />}
        {currentTab === 2 && <InformationCenter />}
        {currentTab === 3 && <Student />}
        {currentTab === 4 && <Staff />}
        {currentTab === 5 && <LaptopRental />}
        {currentTab === 6 && <Admin />}
        {currentTab === 7 && <Setting />}
    </div>;
}

export default ContainerTab;